import React from 'react';
import { motion } from 'framer-motion';
import { Bot, MessageSquare, BarChart3 } from 'lucide-react';
const assistants = [{
  icon: Bot,
  title: '1) Asistente de Contenido',
  description: 'Calendario semanal + piezas listas con ángulos que venden en mercados saturados (sin sonar IA).'
}, {
  icon: MessageSquare,
  title: '2) Asistente de Leads/DMs',
  description: 'Respuestas cortas que califican y mueven a acción, sin presión ni guiones robóticos.'
}, {
  icon: BarChart3,
  title: '3) Asistente de Reporting',
  description: 'Reporte semanal que termina en 3 acciones claras y 1 hipótesis a probar.'
}];
export function ProductSection() {
  return <section className="w-full py-24 px-6 bg-[#050505]" data-id="element-103">
      <div className="max-w-5xl mx-auto" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 space-y-4" data-id="element-105">
          <h2 className="text-3xl md:text-5xl font-bold text-[#f0f0f0]" data-id="element-106">
            Sistema "Asistentes Listos"
          </h2>
          <p className="text-xl text-[#00d4aa]" data-id="element-107">
            Para Infoproductos (sin código)
          </p>
          <p className="text-gray-400 max-w-2xl mx-auto pt-4" data-id="element-108">
            Un ebook operativo + plantillas para construir 3 Custom GPTs.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-109">
          {assistants.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#0a0f0d] border border-gray-800 p-8 rounded-xl hover:border-[#00d4aa]/30 transition-colors duration-300 group" data-id="element-110">
              <div className="w-12 h-12 bg-[#00d4aa]/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#00d4aa]/20 transition-colors" data-id="element-111">
                <item.icon className="w-6 h-6 text-[#00d4aa]" data-id="element-112" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-113">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-114">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}